import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=5b01ac8b&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=5b01ac8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01ac8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b01ac8b')) {
      api.createRecord('5b01ac8b', component.options)
    } else {
      api.reload('5b01ac8b', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=5b01ac8b&scoped=true", function () {
      api.rerender('5b01ac8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/ChangePassword.vue"
export default component.exports